import { z } from "zod";

// Bulk counterparty reassignment is restricted to Draft invoices only — see
// InvoiceController#bulkUpdateInvoiceCounterparty. Any non-draft invoice in
// the selection is rejected wholesale (400), not silently skipped, so the
// frontend must pre-filter or disable the action rather than relying on this
// endpoint to partially apply.
export const bulkUpdateInvoiceCounterpartyBodySchema = z.object({
    invoiceIds: z.array(z.string().uuid()).min(1).max(200),
    counterpartyId: z.string().uuid().nullable(),
});

export type BulkUpdateInvoiceCounterpartyBody = z.infer<
    typeof bulkUpdateInvoiceCounterpartyBodySchema
>;
